import { Typography } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import React from 'react';
import { getDisplayHeader } from '../../utils/order-details/OrderDetailsUtils';
import { OrderStatus } from '../purchase-history/delivery-tracker/OrderStatus';
export var OrderDetailsMainTitle = function (_a) {
    var deliveryTrackerData = _a.deliveryTrackerData, fulfillmentGroup = _a.fulfillmentGroup, index = _a.index, isReturnedMultiReturn = _a.isReturnedMultiReturn, salesDate = _a.salesDate, deliveryTrackerLoaded = _a.deliveryTrackerLoaded;
    if (isReturnedMultiReturn) {
        return (React.createElement("div", { className: classNames('sui-mb-4 md:sui-mb-6 md:sui-mt-8', {
                'sui-mt-[64px]': index === 0,
            }), "data-testid": "order-details-return-header" },
            React.createElement(Typography, { variant: "h3" }, getDisplayHeader(fulfillmentGroup))));
    }
    return (React.createElement("div", { className: classNames('sui-mb-4 md:sui-mb-6 md:sui-mt-8', {
            'sui-mt-[64px]': index === 0,
        }) },
        React.createElement(OrderStatus, { deliveryTrackerData: deliveryTrackerData, deliveryTrackerLoaded: deliveryTrackerLoaded, fulfillmentGroup: fulfillmentGroup, fulfillmentType: fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType, page: "order-details", salesDate: salesDate, variant: "card" })));
};
